(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.controller
  (:require
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.controller
    :refer [portfolio-locations]]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn- portfolio-overview-figures
  [data]
  [["Investment year" (:investment-year data)]
   ["Location" (:location data)]
   ["Source" (:source data)]
   ["Description" (:description data)]
   ["Investment at cost M€" (:investment-at-cost-meur data)]
   ["Current NAV M€" (:current-nav-meur data)]
   ["LTV%" (util/->percent-1-decimal (:ltv-pct data))]
   ["Fund's total ownership" (util/->percent-1-decimal (:funds-total-ownership data))]
   ["Gross portfolio IRR (current)" (util/->percent-1-decimal (:gross-portfolio-irr-current data))]
   ["Lettable area in total" (:lettable-area-in-total data)]
   ["Case team" (:case-team data)]])

(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  {:holding-name       (:holding-name report-data)
   :reference-date     (get-in report-data [:reference-date])
   :report-id          (:report-id props)
   :portfolio-summary-text (report-ctl/rich-content props :portfolio-summary-text)
   :recent-development-text (report-ctl/rich-content props :recent-development-text)
   :overview           (report-ctl/with-footnote
                        props
                        :overview-footnotes
                        (get-in report-data [:basic-information-primary]))
   :map-data           (report-ctl/with-footnote
                        props
                        :map-data-footnotes
                        (portfolio-locations map-topo (:chart-data-map report-data)))
   :portfolio-overview (report-ctl/with-footnote
                        props
                        :overview-table-footnotes
                        (:portfolio-overview report-data))})
